var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 4C15.75 6.76143 13.2876 9 10.25 9C7.21243 9 4.75 6.76143 4.75 4C4.75 3.95891 4.75055 3.91794 4.75163 3.87708C3.7993 4.19002 2.63103 4.5977 1.91372 4.85053C1.51522 4.99098 1.25 5.36777 1.25 5.79029V8.5C1.25 9.05228 1.69772 9.5 2.25 9.5H4C4.13807 9.5 4.25 9.61193 4.25 9.75V16.4509C4.25 16.7834 4.4149 17.0928 4.71005 17.2459C5.54781 17.6803 7.49373 18.5 10.25 18.5C13.0063 18.5 14.9522 17.6803 15.79 17.2459C16.0851 17.0928 16.25 16.7834 16.25 16.4509V9.625C16.25 9.55596 16.306 9.5 16.375 9.5H18.25C18.8023 9.5 19.25 9.05228 19.25 8.5V5.79028C19.25 5.36776 18.9848 4.99097 18.5863 4.85052C17.869 4.59769 16.7007 4.19001 15.7484 3.87707C15.7495 3.91793 15.75 3.95891 15.75 4ZM5.773 3.5931C6.75767 3.39913 7.25 3.56846 7.25 3.56846C7.25 5.24441 8.59315 6.5 10.25 6.5C11.9069 6.5 13.25 5.24441 13.25 3.56846C13.25 3.56846 13.7423 3.39913 14.727 3.59309C14.7422 3.72689 14.75 3.86264 14.75 4C14.75 6.20914 12.7353 8 10.25 8C7.76472 8 5.75 6.20914 5.75 4C5.75 3.86264 5.75779 3.7269 5.773 3.5931Z",
    fill: "#14213D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShirt);
export default __webpack_public_path__ + "static/media/icon-shirt.e14d5db3c02317694021e2aedbf65882.svg";
export { ForwardRef as ReactComponent };